import { useEffect, useState } from "react";
import { BolToolBarItemsCaptainToSign,
        BolToolBarItemsCaptainRelease,
        BolToolBarItemsCaptainConfirmAnnulate,
        BolToolBarItemsForwarderRelease,
        BolToolBarItemsOwnerIssued,
        BolToolBarItemsOwnerDraftToCorrectToSign,
        ManToolBarItemsCaptainToSign,
        ManToolBarItemsCaptainRelease,
        ManToolBarItemsForwarderRelease,
        ManToolBarItemsOwnerDraftToCorrectToSign
} from "../../ToolBarMenuItems/ToolBalMenuItems"

function useOnChangeToolBarMenu(auth, selectedCargoCaseBol, selectedCargoCaseMan) {

    const [itemsToolBarMenu, setItemsToolBarMenu] = useState([]);

    useEffect(() => {
        let isMount = true;

        if (selectedCargoCaseBol !== undefined) {
            if (auth?.roles[0] === 'CAPTAIN' && selectedCargoCaseBol[0]?.status === 'TO_SIGN') {
                isMount && setItemsToolBarMenu(BolToolBarItemsCaptainToSign);
            } else if (auth?.roles[0] === 'CAPTAIN' && selectedCargoCaseBol[0]?.status === 'WAIT_DISCHARGE') {
                isMount && setItemsToolBarMenu(BolToolBarItemsCaptainRelease);
            } else if (auth?.roles[0] === 'CAPTAIN' && selectedCargoCaseBol[0]?.status === 'WAIT_CANCEL') {
                isMount && setItemsToolBarMenu(BolToolBarItemsCaptainConfirmAnnulate);
            } else if (auth?.roles[0] === 'FORWARDER' && selectedCargoCaseBol[0]?.status === 'WAIT_DISCHARGE') {
                isMount && setItemsToolBarMenu(BolToolBarItemsForwarderRelease);
            } else if (auth?.user?.organization?.id === selectedCargoCaseBol[0]?.owner?.id && selectedCargoCaseBol[0]?.status === 'ISSUED' && auth?.roles[0] === 'USER') {
                isMount && setItemsToolBarMenu(BolToolBarItemsOwnerIssued);
            } else if (auth?.user?.organization?.id === selectedCargoCaseBol[0]?.owner?.id && selectedCargoCaseBol[0]?.status === 'DRAFT' && auth?.roles[0] === 'USER') {
                isMount && setItemsToolBarMenu(BolToolBarItemsOwnerDraftToCorrectToSign);
            } else if (auth?.user?.organization?.id === selectedCargoCaseBol[0]?.owner?.id && selectedCargoCaseBol[0]?.status === 'TO_CORRECT' && auth?.roles[0] === 'USER') {
                isMount && setItemsToolBarMenu(BolToolBarItemsOwnerDraftToCorrectToSign);
            } else if (auth?.user?.organization?.id === selectedCargoCaseBol[0]?.owner?.id && selectedCargoCaseBol[0]?.status === 'TO_SIGN' && auth?.roles[0] === 'USER') {
                isMount && setItemsToolBarMenu(BolToolBarItemsOwnerDraftToCorrectToSign);
            }
        } else if (selectedCargoCaseMan !== undefined) {
            if (auth?.roles[0] === 'CAPTAIN' && selectedCargoCaseMan[0]?.status === 'TO_SIGN_CAPTAIN') {
                isMount && setItemsToolBarMenu(ManToolBarItemsCaptainToSign);
            } else if (auth?.roles[0] === 'CAPTAIN' && selectedCargoCaseMan[0]?.status === 'ISSUED') {
                isMount && setItemsToolBarMenu(ManToolBarItemsCaptainRelease);
            } else if (auth?.roles[0] === 'FORWARDER' && selectedCargoCaseMan[0]?.status === 'ISSUED') {
                isMount && setItemsToolBarMenu(ManToolBarItemsForwarderRelease);
            } else if (auth?.user?.organization?.id === selectedCargoCaseMan[0]?.shipper?.id && selectedCargoCaseMan[0]?.status === 'DRAFT' && auth?.roles[0] === 'USER') {
                isMount && setItemsToolBarMenu(ManToolBarItemsOwnerDraftToCorrectToSign);
            } else if (auth?.user?.organization?.id === selectedCargoCaseMan[0]?.shipper?.id && selectedCargoCaseMan[0]?.status === 'TO_CORRECT' && auth?.roles[0] === 'USER') {
                isMount && setItemsToolBarMenu(ManToolBarItemsOwnerDraftToCorrectToSign);
            } else if (auth?.user?.organization?.id === selectedCargoCaseMan[0]?.shipper?.id && selectedCargoCaseMan[0]?.status === 'TO_SIGN_CAPTAIN' && auth?.roles[0] === 'USER') {
                isMount && setItemsToolBarMenu(ManToolBarItemsOwnerDraftToCorrectToSign);
            } else if (auth?.user?.organization?.id === selectedCargoCaseMan[0]?.shipper?.id && selectedCargoCaseMan[0]?.status === 'SIGNED_CAPTAIN' && auth?.roles[0] === 'USER') {
                isMount && setItemsToolBarMenu(ManToolBarItemsOwnerDraftToCorrectToSign);
            } else if (auth?.user?.organization?.id === selectedCargoCaseMan[0]?.shipper?.id && selectedCargoCaseMan[0]?.status === 'TO_SIGN_CUSTOM' && auth?.roles[0] === 'USER') {
                isMount && setItemsToolBarMenu(ManToolBarItemsOwnerDraftToCorrectToSign)
            }
        } else {
            setItemsToolBarMenu([])
        }

        return () => {
            isMount = false;
        }
    },[auth, selectedCargoCaseBol, selectedCargoCaseMan])

    return {itemsToolBarMenu};
}

export default useOnChangeToolBarMenu;
